import React, { useState, useEffect } from 'react'
import Cloathing from './components/Cloathing'
import Roadmap from './components/Roadmap'
import About from './components/About'
import data from './data'
import Page1 from './components/Page1'
import Screen from './components/Screen'
import Contact from './components/Contact'

function App() {

    const [questions, setQuestions] = useState(data)

    return (
        <main>
            <Page1 />
            <Roadmap />
            <Screen />
            <Cloathing />
            <section className='page5' id='about'>
                <div className='container'>
                    <h3>Get to know Armadillos NFT</h3>
                    <div className='info'>
                        {questions.map((question) => {
                            return (
                                <About key={question.id} {...question} />
                            )
                        })}
                    </div>
                </div>
            </section>
            <Contact />
        </main>
    )
}
export default App;
